import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Eye, EyeOff, Loader2, Trash2, X } from "lucide-react";

export function BulkBar({ count, total, onSelectAll, onClear, onAction, busy }) {
  const [confirm, setConfirm] = useState(false);
  const [typed, setTyped] = useState("");
  const label = `${count} question${count === 1 ? "" : "s"}`;
  return (
    <div className="sticky top-20 z-20 flex flex-wrap items-center gap-2 rounded-2xl border border-primary/30 bg-card/95 px-4 py-3 shadow-lg backdrop-blur" data-testid="bulk-bar">
      <span className="text-sm font-semibold text-foreground" data-testid="bulk-count">{label} selected</span>
      {total > count && <button type="button" onClick={onSelectAll} className="text-xs text-primary underline" data-testid="bulk-select-all-matching">Select all {total} matching</button>}
      <button type="button" onClick={onClear} className="flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground" data-testid="bulk-clear"><X className="h-3 w-3" /> Clear</button>
      <div className="ml-auto flex flex-wrap gap-2">
        <Button size="sm" disabled={busy} onClick={() => onAction("publish")} className="rounded-full" data-testid="bulk-publish">
          {busy ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <Eye className="mr-1.5 h-4 w-4" />} Republish
        </Button>
        <Button size="sm" variant="outline" disabled={busy} onClick={() => onAction("draft")} className="rounded-full" data-testid="bulk-unpublish"><EyeOff className="mr-1.5 h-4 w-4" /> Unpublish</Button>
        <Button size="sm" variant="ghost" disabled={busy} onClick={() => { setTyped(""); setConfirm(true); }} className="rounded-full text-destructive hover:text-destructive" data-testid="bulk-delete"><Trash2 className="mr-1.5 h-4 w-4" /> Delete</Button>
      </div>
      <Dialog open={confirm} onOpenChange={setConfirm}>
        <DialogContent data-testid="bulk-delete-dialog">
          <DialogHeader>
            <DialogTitle>Delete {label}?</DialogTitle>
            <DialogDescription>This permanently removes them and their word studies, Look Closer items and links. Type DELETE to confirm.</DialogDescription>
          </DialogHeader>
          <Input value={typed} onChange={(e) => setTyped(e.target.value)} placeholder="DELETE" autoFocus data-testid="bulk-delete-input" />
          <DialogFooter>
            <Button variant="outline" onClick={() => setConfirm(false)} className="rounded-full" data-testid="bulk-delete-cancel">Cancel</Button>
            <Button disabled={typed !== "DELETE" || busy} onClick={() => { setConfirm(false); onAction("delete"); }} className="rounded-full bg-destructive text-destructive-foreground hover:bg-destructive/90" data-testid="bulk-delete-confirm">
              Delete {label}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
